module.exports = __webpack_public_path__ + "assets/img/logo20_white.802bfe42.png";